module.exports = __webpack_public_path__ + "static/media/Node.a38e1bc0.svg";